import React from 'react'
import Top_heading from './component/Top_heading'
import ServicesCounter from './services-component/ServicesCounter'
import Web_Dev_Services from './services-component/Web_Dev_Services'
import CaseStudy from './services-component/CaseStudy'
import ContactArea from './services-component/ContactArea'
import Faq_s from './services-component/Faq_s'
import Main_Heading from './services-component/Main_Heading'
import Stratergy_img_section from './services-component/Stratergy_img_section'
import Carousel from './services-component/Carousel_S';

export default function Stratergy_Positioning() {
  return (
    <>
      <Top_heading Heading="STRATERGY & POSITIONING"/>


      <Main_Heading SideHeading="AWARD-WINNING 
DIGITAL MARKETING 
AGENCY DESIGNED 
TO DRIVE

"
ButtonText="Share Your Project"
para2="Digital Marketing Services that are aligned to your business' growth targets
By implementing a strategy-first approach, our team identifies the right approach aligned to 
the goals of your business. This process includes a full competitor audit together with an outline of the messaging, content and services required to achieve your business' growth targets."
para3="Our digital marketing strategies are designed to meet the customer where they are at in the 
buyer's journey and ultimately convert them into loyal customers and long standing brand advocates. This is done through smart and personalized digital marketing services, creative 
thinking and transformative technology, ensuring effective and measurable results."
para1="If your business has clear growth targets, partner with NEXA to achieve these.This is done 
through smart and personalized digital marketing services, creative thinking and transformative technology, ensuring effective and measurable results."
/>

    
      <Stratergy_img_section/>

      <ServicesCounter/>

      <Carousel/>

      <Web_Dev_Services/>

      <CaseStudy/>
    
      <Faq_s/>
     
      <ContactArea/>
    </>
  )
}
